<template>
  <div>
    <h3>Sidebar test</h3>

    <!-- <routePlannedDate /> -->

    <!-- <stopdata2 :stopId="stopId" v-model="showScheduleForm" /> -->
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
          Click Me
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Privacy Policy
        </v-card-title>

        <v-card-text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> I accept </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <dialogInfo :message="message" v-model="showScheduleForm" /> -->

    <Loader v-model="showLoader" />

    <v-btn
      :disabled="dialog"
      :loading="dialog"
      class="white--text"
      color="purple darken-2"
      @click="showLoader = true"
    >
      Start loading
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isConnected: false,
      socketMessage: "",
      showLoader: false, //true,
      dialog: false,
      message: "asdfasdfasdf sdfsd",
    };
  },

  sockets: {
    /* connect() {
      // Fired when the socket connects.
      this.isConnected = true;
    },*/

    disconnect() {
      this.isConnected = false;
    },

    // Fired when the server sends something on the "messageChannel" channel.
    messageChannel(data) {
      this.socketMessage = data;
    },
  },

  methods: {
    pingServer() {
      // Send the "pingServer" event to the server.
      this.$socket.emit("message", "PING!");
    },
  },
};
</script>

<style >
/* div.v-picker__body.v-picker__body--no-title {
  background-color: red !important;
  color: white;
  width: 299px;
  height: 400px;
} */
</style>